import React from 'react';
import { Controller } from 'react-hook-form';
import { InputField } from '../../../../../../Form';
import useMeasureFilterFormContext from '../../utils/useMeasureFilterFormContext';

interface IProps {
  filterIndex: number;
}

const SingleMeasureFilterMeasureKey = ({ filterIndex }: IProps) => {
  const { control } = useMeasureFilterFormContext();

  return (
    <Controller
      name={`filters.${filterIndex}.measureKey`}
      control={control}
      render={({ field }) => <InputField {...field} disabled={true} />}
    />
  );
};

export default SingleMeasureFilterMeasureKey;
